// Detecció de connectivitat pel portal /Control_Horari.
//
// El fitxatge real (chFitxatge.js) no depèn de cap comprovació prèvia: ja
// desa sempre a la cua local i intenta sincronitzar de seguida, gestionant
// per si sol l'èxit o la fallada de la petició real. Per això aquí NO es fa
// cap "ping" continu al backend (ControlHorariHealth.php): saber-ho abans no
// canvia res del que passarà en fitxar, i fer-ho en bucle només generava
// trànsit innecessari (una comprovació cada 20s per cada pantalla oberta).
//
// El hook `useChEstatConnexio()` es limita, doncs, a navigator.onLine (gratuït,
// sense petició de xarxa), per a la insígnia de la capçalera i els avisos
// genèrics "Sense connexió" d'Inici/Fitxar.
//
// `chComprovarApiAccessible()` es manté com a comprovació real puntual
// (no periòdica): la pantalla Fitxar la crida un únic cop en muntar-se per
// poder avisar, si escau, que el servidor no respon encara que hi hagi
// xarxa (Wi-Fi connectat però backend aturat/inaccessible).

import { useEffect, useState } from "react";
import { API_URL } from "../../utils/config";

const TIMEOUT_COMPROVACIO_MS = 4000;

export async function chComprovarApiAccessible() {
  if (typeof fetch === "undefined") return false;
  const teAbort = typeof AbortController !== "undefined";
  const controller = teAbort ? new AbortController() : null;
  const timeoutId = controller ? setTimeout(() => controller.abort(), TIMEOUT_COMPROVACIO_MS) : null;
  try {
    const resposta = await fetch(`${API_URL}/ControlHorariHealth.php`, {
      method: "GET",
      cache: "no-store",
      signal: controller ? controller.signal : undefined,
    });
    return resposta.ok;
  } catch {
    return false;
  } finally {
    if (timeoutId) clearTimeout(timeoutId);
  }
}

// Hook compartit pel capçalera (badge) i els avisos genèrics d'Inici/Fitxar,
// perquè tots facin servir exactament el mateix criteri. Basat només en
// navigator.onLine + events online/offline (sense cap petició de xarxa).
export function useChEstatConnexio() {
  const [xarxaDisponible, setXarxaDisponible] = useState(
    typeof navigator === "undefined" ? true : navigator.onLine
  );

  useEffect(() => {
    const marcarOnline = () => setXarxaDisponible(true);
    const marcarOffline = () => setXarxaDisponible(false);
    window.addEventListener("online", marcarOnline);
    window.addEventListener("offline", marcarOffline);
    return () => {
      window.removeEventListener("online", marcarOnline);
      window.removeEventListener("offline", marcarOffline);
    };
  }, []);

  return {
    estat: xarxaDisponible ? "CONNECTAT" : "SENSE_XARXA",
    connectat: xarxaDisponible,
    xarxaDisponible,
  };
}
